import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const query = graphql`
  query StoresQuery {
    allMcStoreMcStore {
      edges {
        node {
          name
          drupal_id
          field_mc_location {
            lat
            lon
          }
          dsap_plant_id
          field_mc_store_opening_times
          field_mc_store_email
          field_mc_store_description
          field_mc_store_delivery_estimate
          field_mc_store_address {
            address_line1
            address_line2
            country_code
            administrative_area
            locality
            postal_code
          }
          field_mc_store_phone_number
          field_mc_store_pickup_estimate
        }
      }
    }
  }
`

export const useStores = () => {
  const { allMcStoreMcStore } = useStaticQuery(query)
  return useMemo(() => (allMcStoreMcStore.edges.map(({ node }) => node)), [allMcStoreMcStore])
}
